import $ from 'jquery';

import * as success from '../actions/DnevnaEvidencijaActions';

import endpoint from '../environments/endpoints';
import { showAlert } from '../utils/ErrorHandler';

export function getDnevnaEvidencija(startDateTime, endDateTimeIncl, mjestoId, onSuccess, onError) {
    return function(dispatch) {
        $.ajax({
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + sessionStorage.token
            },
            url: endpoint.apiEndpoint + 'radnje?startDateTime=' + startDateTime + 'T00:00&endDateTimeIncl=' + endDateTimeIncl + 'T23:59&mjestoId=' + mjestoId
        })
            .done(data => {
                dispatch(success.getDnevnaEvidencija(data));
                if (onSuccess) {
                    onSuccess();
                }
            })
            .fail(error => {
                showAlert(error);
            });
    };
}
